<template>
    <ul class="form-error">
        <li v-for="(error, index) in errors" :key="`${error}_${index}`">{{ error }}</li>
    </ul>
</template>

<script>
export default {
    name: 'FormError',
    props: {
        errors: {
            type: Array,
            default() {
                return [];
            },
        },
    },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.form-error {
    display: block;
    margin: 20px 0;
    color: $error;

    li {
        font-size: 14px;
    }
}
</style>
